import { render, staticRenderFns } from "./Basic_card.vue?vue&type=template&id=2a48f88a&"
import script from "./Basic_card.vue?vue&type=script&lang=js&"
export * from "./Basic_card.vue?vue&type=script&lang=js&"
import style0 from "./Basic_card.vue?vue&type=style&index=0&id=2a48f88a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports